var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalSup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.75 45H6.25V50H53.75V45Z",
    fill: "#17B9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 52.5H5C4.33696 52.5 3.70107 52.7634 3.23223 53.2322C2.76339 53.7011 2.5 54.337 2.5 55V57.5H57.5V55C57.5 54.337 57.2366 53.7011 56.7678 53.2322C56.2989 52.7634 55.663 52.5 55 52.5Z",
    fill: "#17B9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22.5H12.5V42.5H17.5V22.5Z",
    fill: "#17B9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22.5H27.5V42.5H32.5V22.5Z",
    fill: "#17B9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 22.5H42.5V42.5H47.5V22.5Z",
    fill: "#17B9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.125 14.25L30 2.5L3.875 14.25C3.4677 14.4704 3.12597 14.7947 2.88448 15.1898C2.64299 15.585 2.51034 16.037 2.5 16.5V17.5C2.5 18.163 2.76339 18.7989 3.23223 19.2678C3.70107 19.7366 4.33696 20 5 20H55C55.663 20 56.2989 19.7366 56.7678 19.2678C57.2366 18.7989 57.5 18.163 57.5 17.5V16.5C57.4897 16.037 57.357 15.585 57.1155 15.1898C56.874 14.7947 56.5323 14.4704 56.125 14.25Z",
    fill: "#17B9DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalSup);
export default __webpack_public_path__ + "static/media/legalSup.281b880fa0ff459a7bdd3561eb9f4001.svg";
export { ForwardRef as ReactComponent };